import React, { Component } from 'react';
import { translate } from 'react-i18next';
import axios from 'axios';
import { currentHttpOptions } from '../../../../common/utilities/utilitiesFunctions';
import { Grid, ListItem, ListItemIcon, Typography, withStyles } from '@material-ui/core';
import MainWorkPlanList from '../MainWorkPlanList';
import WorkPlanArchives from '../WorkPlanArchives';
import WorkPlanAudits from '../WorkPlanAudits';
import { HomeRounded, Archive } from '@material-ui/icons';
import clsx from 'clsx';
import WorkPlan from '../WorkPlan';
import { app } from '../../../styles/workplanStyles';
import { connect } from 'react-redux';
import TextBoxInfo from '../../../assets/TextBoxSearch';
import Backdrop from './backdropWrapper'
import './App.scss';
import AppDrawer from '../../../../common/components/UI/AppDrawer/AppDrawer';
import AppBar from '../../../../common/components/UI/AppBar';
import AppBarContent from '../../../../common/components/UI/AppBarContent';

const styles = theme => (app(theme));

const emptyPublicConfigs = {
    appEnvironment: '',
    isMultiLanguage: true,
    version: '',
};

const appIcon = {
	workplanManagerList: (<HomeRounded />),
	workplanManagerAudits: (<TextBoxInfo />),
	workplanManagerArchives: (<Archive />),
};

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
			applications: [{ "name": "workplanManager", "api": "dimensions", "status": "active", "env_sso": "active", "sso": true, "env": ["admin"], "managerViews": ["List", "Audits", "Archives"], "token": false }],
			applicationSelected: 'workplanManager',
			viewSelected: 'List',
		}
		document.title = "Workplan Manager (Manager)"
        this.init();
	}

    init = async () => {
        const { data: publicConfigs } = await axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/public/configs', currentHttpOptions());
        Object.keys(emptyPublicConfigs).forEach((key) => {
            sessionStorage.setItem(key, publicConfigs[key]);
        });
		this.setState({	applicationSelected: 'workplanManager' });
    }

	handleSideMenu = (event, extend) => {
		event.stopPropagation()
		this.setState({ extended: extend })
	}

	handleOnClickApplication = (app, view) => {
		this.setState({
			applicationSelected: app,
			viewSelected: view,
			extended: false
		});
		localStorage.setItem('adminAppSelected', app);
		localStorage.setItem('adminViewSelected', view);
	}

	render() {
		const { selectedWorkPlan, refreshAdmin, showRightPanelList, classes, t } = this.props;
		const { weekStartDay, applicationSelected, viewSelected, applications, extended } = this.state;
		const appComponent = {
			workplanManager: <MainWorkPlanList refreshAdmin={refreshAdmin} />,
			workplanManagerList: <MainWorkPlanList refreshAdmin={refreshAdmin} />,
			workplanManagerAudits: (<WorkPlanAudits refreshAdmin={refreshAdmin} />),
			workplanManagerArchives: (<WorkPlanArchives refreshAdmin={refreshAdmin} />),
		}
		let app = appComponent[applicationSelected + viewSelected] || appComponent.workplanManagerList;

		let mainContent = '';
		const drawerItems = applications.map((app) => (
			app.managerViews.map((view) => (
				<ListItem
					key={view}
					button
					className={classes.listItemNoHover}
					classes={{ selected: classes.selected }}
					onClick={() => { this.handleOnClickApplication(app.name, view) }}
					selected={app.name === applicationSelected && view === viewSelected}
				>
					<ListItemIcon
						className={clsx(classes.icon, classes.navElement, {
							[classes.selected]: app.name === applicationSelected && view === viewSelected
						})}
					>
						{appIcon[app.name + view]}
					</ListItemIcon>
					<Typography
						className={classes.navElement}
					>
						{this.props.t(app.name + ':settings.appNameSUB' + view)}
					</Typography>
				</ListItem>
			))
		));
		if (selectedWorkPlan === '' || (selectedWorkPlan !== '' && showRightPanelList)) {
			mainContent = <React.Fragment>
				<Grid item xs={12} className={classes.content}>
					<div className={classes.contentWrapper}>
						<AppDrawer
							applicationSelected={applicationSelected}
							applications={applications}
							appIcon={appIcon}
							extended={extended}
							handleSideMenu={this.handleSideMenu}
							handleOnClickApplication={this.handleOnClickApplication}
							renderedDrawerContent={drawerItems}
							t={this.props.t}
						/>
						<AppBar>
							<AppBarContent
								name={t('settings.appName')}
								pageName={t(`settings.appNameSUB${viewSelected}`)}
							/>
						</AppBar>
						<div className='workPlan-app-container'>{app}</div>
					</div>
				</Grid>
			</React.Fragment>
		} else {
			mainContent = <WorkPlan
				weekStartDay={weekStartDay}
				refreshAdmin={refreshAdmin}
			/>;
		}

		return (
			<React.Fragment>
				{mainContent}
				<Backdrop />
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		selectedWorkPlan: state.selectedWorkPlan,
		showRightPanelList: state.showRightPanelList
	}
}

export default connect(mapStateToProps)(translate('workplanManager')(withStyles(styles)(App)));